module.exports = "<div class=\"details-footer b-modal-hero__footer\">\n\n</div>"